import * as React from 'react';
import { Caption1, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { CheckmarkCircleFilled, ErrorCircleFilled, WarningFilled } from '@fluentui/react-icons';

interface Props {
  id: string;
  hint?: React.ReactNode;
  validationMessage?: React.ReactNode;
  validationState?: 'error' | 'warning' | 'success';
}

export function FormFieldDescription({ id, hint, validationMessage, validationState }: Props) {
  const classes = useStyles();
  return (
    <div>
      {validationMessage ? (
        <Caption1 block id={`error-${id}`} className={classes.validation}>
          {validationState === 'error' ? <ErrorCircleFilled className={classes.error} /> : null}
          {validationState === 'warning' ? <WarningFilled className={classes.warning} /> : null}
          {validationState === 'success' ? <CheckmarkCircleFilled className={classes.success} /> : null}
          {validationMessage}
        </Caption1>
      ) : null}
      {hint ? (
        <Caption1 block id={`desc-${id}`} className={classes.hint}>
          {hint}
        </Caption1>
      ) : null}
    </div>
  );
}

const useStyles = makeStyles({
  validation: {
    display: 'inline-flex',
    flexDirection: 'row',
    columnGap: tokens.spacingHorizontalXS,
    alignItems: 'center',
    ...shorthands.margin('0'),
  },
  hint: {
    ...shorthands.margin('0'),
  },
  error: {
    color: tokens.colorPaletteRedForeground1,
  },
  warning: {
    color: tokens.colorPaletteDarkOrangeForeground1,
  },
  success: {
    color: tokens.colorPaletteGreenForeground1,
  },
});
